import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestMerge = get('guest.routes.merge');

export const getGuestMergeData = createSelector(getGuestMerge, get('data'));

export const getIsFetching = createSelector(getGuestMerge, get('fetching'));

export const getIsFetched = createSelector(getGuestMerge, get('fetched'));

export const getIsSaving = createSelector(getGuestMerge, get('saving'));

export const getIsSaved = createSelector(getGuestMerge, get('saved'));
